<template lang="pug">
.account.container
  reports-modal
  .row
    .col-12.col-md-9
      plaid(:profile='profile', :updated-user-accounts='userAccountsUpdated')
      section#reports.card-item.col-12
        h5 Reports
        p Each month, we process you reports and place your final reports here.
        .empty.text-center(v-if='reports.length === 0')
          strong No reports here yet.
          br
          small We will upload these when we are done processing.
        .reports
          .report-item.d-flex.justify-content-between.align-items-center(v-for='report in reports')
            span {{ report.type }} - {{ report.startDate }}
            button.btn.btn-primary(@click='viewReport(report)') View
      section#reports.card-item.col-12
        transactions
    .col-12.col-md-3
      section.card-item.col-12
        h5 Your Account
        strong Logged in with {{user.email}}
      section.card-item.col-12
        h5 Subscription
        div(v-if='profile && profile.subId')
          strong Subscribed to the {{ planOptions[profile.subId.plan.id].name }} plan
        button.btn.btn-danger(v-if='profile.subId', @click='cancel(profile.subId.id)', :disabled='loading') Cancel
        div(v-else)
          subscribe-field
</template>

<style lang="scss" scoped>
  .account {
    text-align: left;
    padding-top: 3rem;
  }

  .report-item {
    background: #efefef;
    padding: 1.5rem 1rem;
    margin-bottom: .5rem;
    border-radius: 3px;
  }

  .card-item {
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
    border-radius: 3px;
    border: none;
    padding: 18px 33px 20px 33px;
    margin-bottom: 1rem;
  }

  .empty {
    background: #efefef;
    margin: 0 auto;
    margin-top: 2rem;
    margin-bottom: 4rem;
    width: 300px;
    border-radius: 4px;
    padding: 1rem 2rem;
  }

  .file {
    background: #efefef;
    padding: 1rem;
    border-radius: 4px;
    margin-bottom: 1rem;
  }

  #reports {
    .empty {
      margin-bottom: 2rem;
    }
  }
</style>

<script>
import axios from 'axios'

import { getUser, getPlaidTransactions, getPlaidPublicToken, connectAccountWithPlaid } from '../lib/api'
import FileUpload from './FileUpload'
import ReportsModal from './ReportsModal'
import Plaid from './Plaid'
import SubscribeField from './SubscribeField'
import Transactions from './Transactions'
import firebaseMixin from '../mixins/firebase'
import stripe from '../mixins/stripe'

export default {
  mixins: [stripe],
  components: {
    FileUpload,
    Plaid,
    SubscribeField,
    ReportsModal,
    Transactions
  },
  data () {
    return {
      files: [],
      reports: [],
      db: null,
      loading: false,
      profile: {},
      user: {},
      transactions: []
    }
  },
  async mounted () {
    this.profile = await getUser();
    this.user = this.profile;

    // this.transactions = await getPlaidTransactions();

    // const publicToken = await getPlaidPublicToken(this.user.accounts[1]._id);
    // console.log(publicToken)
    // const linkHandler = window.Plaid.create({
    //   apiVersion: 'v2',
    //   env: 'development',
    //   clientName: 'Small Biz Acct',
    //   key: '3bb75f5d33f8369932972f336f5c59',
    //   product: ['transactions'],
    //   token: publicToken,
    //   onSuccess: function(public_token, metadata) {
    //     console.log(public_token, metadata)
    //     connectAccountWithPlaid(public_token)
    //     // You do not need to repeat the /item/public_token/exchange
    //     // process when a user uses Link in update mode.
    //     // The Item's access_token has not changed.
    //   },
    //   onExit: function(err, metadata) {
    //     // The user exited the Link flow.
    //     if (err != null) {
    //       // The user encountered a Plaid API error prior
    //       // to exiting.
    //     }
    //     // metadata contains the most recent API request ID and the
    //     // Link session ID. Storing this information is helpful
    //     // for support.
    //   }
    // });
    // linkHandler.open();
    // console.log(linkHandler);
  },
  methods: {
    async remove (file) {
      if (!confirm('Are you sure you want to remove this file?')) return
      // @TODO:
      this.loading = false
    },
    async cancel (subId) {
      this.loading = true
      if (!confirm('Are you sure you want to cancel?')) return

      // @TODO: 

      this.profile = ''
      this.loading = false
    },
    viewReport (report) {
      this.$root.$emit('smallbiz-show-report', report)
    },
    userAccountsUpdated (data) {
      this.profile.accounts = data.accounts;
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account.vue